<div>
    <app-page-breadcrumb pageTitle="Gestión de Menús" />

    <div class="rounded-2xl border border-gray-200 bg-white px-5 py-5 dark:border-gray-800 dark:bg-white/3">

        <div class="flex items-center justify-between mb-6">
            <h2 class="text-lg font-semibold text-gray-800 dark:text-white">Menús del sistema</h2>
            <button type="button" (click)="openCreate()"
                class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                </svg>
                Nuevo menú
            </button>
        </div>

        @if (loading) {
        <p class="py-12 text-center text-sm text-gray-400">Cargando...</p>
        } @else if (tree.length === 0) {
        <p class="py-12 text-center text-sm text-gray-400">No hay menús registrados.</p>
        } @else {

        <div class="space-y-3">
            @for (node of tree; track node.id) {

            <!-- PARENT NODE -->
            <div class="rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
                <div class="flex items-center justify-between px-4 py-3 bg-gray-50 dark:bg-white/3">
                    <div class="flex items-center gap-3">
                        <button type="button" (click)="toggleExpand(node)"
                            class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-transform"
                            [class.rotate-90]="node.expanded">
                            <svg class="w-4 h-4 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                        <div class="flex items-center gap-2">
                            <span class="font-semibold text-gray-800 dark:text-white text-sm">{{ node.name }}</span>
                            @if (node.path) {
                            <span class="text-xs text-gray-400 font-mono">{{ node.path }}</span>
                            }
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-gray-400 dark:text-gray-500">Orden: {{ node.sortOrder }}</span>
                        <app-badge size="sm" [color]="node.status === 1 ? 'success' : 'error'">
                            {{ node.status === 1 ? 'Activo' : 'Inactivo' }}
                        </app-badge>
                        <button type="button" (click)="openCreate(node.id)"
                            class="p-1.5 rounded-lg text-brand-500 hover:bg-brand-50 dark:hover:bg-brand-900/20 transition-colors" title="Agregar submenú">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                            </svg>
                        </button>
                        <button type="button" (click)="openEdit(node)"
                            class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                        </button>
                        <button type="button" (click)="toggleStatus(node)"
                            class="p-1.5 rounded-lg transition-colors"
                            [class]="node.status === 1 ? 'text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20' : 'text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20'"
                            [title]="node.status === 1 ? 'Desactivar' : 'Activar'">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- CHILDREN -->
                @if (node.expanded && node.children.length > 0) {
                <div class="divide-y divide-gray-100 dark:divide-gray-800">
                    @for (child of node.children; track child.id) {
                    <div class="flex items-center justify-between px-4 py-2.5 pl-12">
                        <div class="flex items-center gap-2">
                            <svg class="w-3 h-3 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                            <span class="text-sm text-gray-700 dark:text-gray-300">{{ child.name }}</span>
                            @if (child.path) {
                            <span class="text-xs text-gray-400 font-mono">{{ child.path }}</span>
                            }
                        </div>
                        <div class="flex items-center gap-2">
                            <span class="text-xs text-gray-400">Orden: {{ child.sortOrder }}</span>
                            <app-badge size="sm" [color]="child.status === 1 ? 'success' : 'error'">
                                {{ child.status === 1 ? 'Activo' : 'Inactivo' }}
                            </app-badge>
                            <button type="button" (click)="openEdit(child)"
                                class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button>
                            <button type="button" (click)="toggleStatus(child)"
                                class="p-1.5 rounded-lg transition-colors"
                                [class]="child.status === 1 ? 'text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20' : 'text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20'">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 115.636 5.636m12.728 12.728L5.636 5.636" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    }
                </div>
                }

                @if (node.expanded && node.children.length === 0) {
                <p class="px-12 py-2 text-xs text-gray-400 italic">Sin submenús</p>
                }
            </div>

            }
        </div>
        }
    </div>

    <!-- MODAL -->
    @if (showModal) {
    <div class="fixed inset-0 z-99999 flex items-center justify-center bg-black/50 p-4" (click)="closeModal()">
        <div class="w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 p-6 shadow-xl" (click)="$event.stopPropagation()">

            <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-5">
                {{ isEditing ? 'Editar menú' : 'Nuevo menú' }}
            </h3>

            <div class="space-y-4">
                <div>
                    <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Nombre *</label>
                    <input type="text" [(ngModel)]="form.name" placeholder="Ej: Facturación"
                        class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500"
                        [class.border-red-400]="formSubmitted && !form.name.trim()" />
                    @if (formSubmitted && !form.name.trim()) {
                    <p class="mt-1 text-xs text-red-500">El nombre es obligatorio</p>
                    }
                </div>

                <div>
                    <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                        Ruta (path)
                        @if (editingHasChildren) {
                        <span class="ml-1 text-amber-500 normal-case font-normal tracking-normal">(deshabilitado — tiene submenús)</span>
                        }
                    </label>
                    <input type="text" [(ngModel)]="form.path" placeholder="Ej: /sales"
                        [disabled]="pathDisabled"
                        class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:opacity-40 disabled:cursor-not-allowed disabled:bg-gray-50 dark:disabled:bg-white/2" />
                    @if (editingHasChildren) {
                    <p class="mt-1 text-xs text-amber-500">Elimina todos los submenús para poder asignar una ruta directa.</p>
                    }
                </div>

                <div>
                    <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Menú padre</label>
                    <app-select
                        placeholder="— Ninguno (menú raíz) —"
                        [options]="parentMenuOptions"
                        [(value)]="parentIdStr">
                    </app-select>
                </div>

                <div>
                    <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Orden *</label>
                    <input type="number" [(ngModel)]="form.sortOrder" min="1"
                        class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500" />
                </div>
            </div>

            <div class="flex justify-end gap-3 mt-6">
                <button type="button" (click)="closeModal()"
                    class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-white/5">
                    Cancelar
                </button>
                <button type="button" (click)="save()" [disabled]="submitting"
                    class="px-4 py-2 text-sm font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
                    {{ submitting ? 'Guardando...' : 'Guardar' }}
                </button>
            </div>
        </div>
    </div>
    }
</div>
